// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1or8_","footer":"ModalCreateQualiphyProcedure_footer__j9rdC","additionData":"ModalCreateQualiphyProcedure_additionData__1ps-s"};